import axios from 'axios';

type TranslationsJson = Record<string, string>;

const logError = (error: any) => {
    const prefix = '[LetsBook] Loading translations failed';

    if (axios.isAxiosError(error)) {
        console.log(
            `${prefix}: ${error.message}. Retrying with fallback URL...`
        );
    } else {
        console.log(
            `${prefix} due to an unknown error. Retrying with fallback URL...`
        );
    }
};

type Options = {
    url: string;
    fallbackUrl?: string;
    forceFallback?: boolean;
};

const fetchTranslations = async ({
    url,
    fallbackUrl,
    forceFallback = false,
}: Options): Promise<TranslationsJson> => {
    const loadFromFallback = async () => {
        if (!fallbackUrl) {
            throw new Error(
                'Cannot load translations from primary URL and no fallback URL was provided.'
            );
        }

        try {
            const fallbackResponse = await axios.get(fallbackUrl);
            return fallbackResponse.data;
        } catch (fallbackError) {
            throw new Error(
                `Cannot load translations from ${url} nor fallback URL ${fallbackUrl}.`
            );
        }
    };

    if (forceFallback) {
        return loadFromFallback();
    }

    try {
        const response = await axios.get<TranslationsJson>(url, {
            timeout: 5000,
        });

        return response.data;
    } catch (error) {
        logError(error);

        return loadFromFallback();
    }
};

export default fetchTranslations;
